import { Component, OnInit } from '@angular/core';
import { ProveedorService } from '../services/proveedor.service';
import { MatDialog } from '@angular/material/dialog';
import { GenericTableHandlerService } from '../shared/GenericTableHandlerService.service';
import { ToastrService } from 'ngx-toastr';
import { SuppliersDialogComponent } from './suppliers-dialog/suppliers-dialog.component';

@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrls: ['./suppliers.component.scss']
})
export class SuppliersComponent  extends GenericTableHandlerService implements OnInit {
  constructor(
    proveedorService: ProveedorService,
    dialog: MatDialog,
    toastr: ToastrService
  ) {
    super(proveedorService, dialog, toastr);
  }

  ngOnInit(): void {
    this.dialogComponent = SuppliersDialogComponent;
    this.initialize(
      {
        title: 'Lista de Proveedores',
        selectable: true,
        stickyHeader: true,
        pageSize: 10,
        pageSizeOptions: [5, 10, 25, 100],
        noDataMessage: 'No hay proveedores registrados',
        columns: [
          { key: 'nombre', title: 'Nombre', sortable: true },
          { key: 'descripcion', title: 'Descripcion', sortable: true, align: 'left' },
          // { key: 'createdAt', title: 'Fecha de Insercion', type: 'number', sortable: true, align: 'center' }
        ]
      },
      null,
      ''// 'v1/productos'
    );

    this.loadData();
  }

  onEdit(item: any): void {
    console.log('Editar proveedor', item);
    this.abrirDialogoProducto(item);
  }
  abrirDialogoProducto(proveedor?: any): void {
    const dialogRef = this.dialog.open(SuppliersDialogComponent, {
      width: '600px',
      data: {
        proveedor: proveedor ? {...proveedor} : undefined,
        isEdit: proveedor,
      }
    });

    dialogRef.afterClosed().subscribe((success: boolean) => {
      console.log('success', success)
      if (success) {
        this.loadData(); // Recargar datos solo si fue exitoso
      }
    });
  }

  onDelete(item: any): void {
    if (confirm('¿Seguro que deseas eliminar este producto?')) {
      this.deleteItem(item.id).subscribe();
    }
  }
}
